<template>
  <div class="container">
    <AppHeader />
    <slot />
  </div>
</template>
